module.exports = require("@material-ui/icons/Dashboard");